(() => {
  if (window.hgLegalGuaranteeReady) return;
  window.hgLegalGuaranteeReady = true;

  let dialog;
  let opener;
  let openerOwner;
  let scrollState;
  let suppressEscapeUp = false;
  let backdropPointer = false;

  const rememberStyles = (element, names) => names.map(name => [
    name, element.style.getPropertyValue(name), element.style.getPropertyPriority(name)
  ]);
  const restoreStyles = (element, values) => values.forEach(([name, value, priority]) => {
    if (value) element.style.setProperty(name, value, priority);
    else element.style.removeProperty(name);
  });

  const lockScroll = () => {
    if (scrollState) return;
    const root = document.documentElement;
    const body = document.body;
    scrollState = {
      x: window.scrollX, y: window.scrollY,
      root: rememberStyles(root, ['overflow', 'scroll-behavior']),
      body: rememberStyles(body, ['position', 'top', 'left', 'width', 'overflow', 'padding-right'])
    };
    const gutter = Math.max(0, window.innerWidth - root.clientWidth);
    const padding = parseFloat(window.getComputedStyle(body).paddingRight) || 0;
    root.style.setProperty('overflow', 'hidden');
    body.style.setProperty('position', 'fixed');
    body.style.setProperty('top', `${-scrollState.y}px`);
    body.style.setProperty('left', `${-scrollState.x}px`);
    body.style.setProperty('width', '100%');
    body.style.setProperty('overflow', 'hidden');
    if (gutter) body.style.setProperty('padding-right', `${padding + gutter}px`);
  };

  const unlockScroll = () => {
    if (!scrollState) return;
    const state = scrollState;
    scrollState = undefined;
    restoreStyles(document.body, state.body);
    restoreStyles(document.documentElement, state.root);
    document.documentElement.style.setProperty('scroll-behavior', 'auto');
    window.scrollTo(state.x, state.y);
    restoreStyles(document.documentElement, state.root.filter(([name]) => name === 'scroll-behavior'));
  };

  const finishClose = () => {
    unlockScroll();
    const target = opener?.isConnected ? opener : openerOwner?.querySelector('[data-hg-legal-guarantee]');
    if (target?.isConnected && target.getClientRects().length) target.focus({ preventScroll: true });
    opener = undefined;
    openerOwner = undefined;
  };

  const close = () => {
    if (!dialog?.open) return;
    dialog.close();
    finishClose();
  };

  const outside = event => {
    if (event.target !== dialog) return false;
    const rect = dialog.getBoundingClientRect();
    return event.clientX < rect.left || event.clientX > rect.right ||
      event.clientY < rect.top || event.clientY > rect.bottom;
  };

  const createDialog = () => {
    const template = document.getElementById('HgLegalGuaranteeTemplate');
    const candidate = template?.content.querySelector('dialog');
    if (!candidate || typeof candidate.showModal !== 'function') return;
    dialog = candidate.cloneNode(true);
    dialog.querySelector('[data-hg-legal-close]').addEventListener('click', close);
    dialog.addEventListener('cancel', event => {
      event.preventDefault();
      event.stopPropagation();
      close();
    });
    dialog.addEventListener('close', () => { if (!dialog.open) finishClose(); });
    dialog.addEventListener('pointerdown', event => { backdropPointer = outside(event); });
    dialog.addEventListener('click', event => {
      if (backdropPointer && outside(event)) close();
      backdropPointer = false;
    });
    document.body.append(dialog);
    return dialog;
  };

  document.addEventListener('click', event => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-hg-legal-guarantee]') : null;
    if (!trigger || event.defaultPrevented || event.button > 0 ||
      event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const modal = dialog || createDialog();
    if (!modal) return; // Keep the ordinary image link when native dialog is unavailable.
    if (!modal.open) {
      opener = trigger;
      openerOwner = trigger.closest('#CartDrawer, .hg-buybox-service, .hg-cart-checkout-trust');
      try {
        modal.showModal();
        lockScroll();
        modal.querySelector('.hg-lg-dialog__body').scrollTop = 0;
        modal.querySelector('#HgLegalGuaranteeTitle').focus({ preventScroll: true });
      } catch {
        if (modal.open) modal.close();
        finishClose();
        return;
      }
    }
    event.preventDefault();
    event.stopPropagation();
  }, true);

  // The theme closes drawers on document keyup. Consume the same Esc release
  // after closing our top-layer dialog, keeping the drawer underneath.
  document.addEventListener('keydown', event => {
    if (!dialog?.open) return;
    if (event.key === 'Escape' || event.code === 'Escape') {
      suppressEscapeUp = true;
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    } else if (event.key === 'Tab') {
      event.stopImmediatePropagation(); // Native modal focus handling remains active.
    }
  }, true);
  document.addEventListener('keyup', event => {
    if ((event.key === 'Escape' || event.code === 'Escape') && (suppressEscapeUp || dialog?.open)) {
      suppressEscapeUp = false;
      event.preventDefault();
      event.stopImmediatePropagation();
      close();
    }
  }, true);
})();
